import { render, staticRenderFns } from "./AdminContact.vue?vue&type=template&id=5e15d4a2&scoped=true&"
import script from "./AdminContact.vue?vue&type=script&lang=js&"
export * from "./AdminContact.vue?vue&type=script&lang=js&"
import style0 from "./AdminContact.vue?vue&type=style&index=0&id=5e15d4a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e15d4a2",
  null
  
)

component.options.__file = "AdminContact.vue"
export default component.exports